import styled from 'styled-components';

import { Text } from '@ovpn-ui/core';
import { media, styledIf } from '@ovpn-ui/styles';
import { sidebarAnimation } from '@ovpn-ui/navigation/Navigation/Navigation/Sidebar/Sidebar.constants';

export const CopyTenant = styled.div<{ $copied: boolean }>`
    position: relative;

    width: 18px;
    height: 18px;
    margin-left: auto;

    opacity: 0;

    transition: opacity ${sidebarAnimation};

    .icon {
        position: absolute;
        top: 0;
        left: 0;

        display: block;
    }

    .icon-copy {
        transition:
            opacity 0.3s,
            transform 0.3s;
    }

    .icon-copied {
        transform: rotate(-180deg) scale(0.5);
        opacity: 0;

        transition:
            opacity 0.3s,
            transform 0.3s;
    }

    ${styledIf('$copied')`
        .icon-copy {
            transform: rotate(180deg) scale(0.5);
            opacity: 0;
        }
        
        .icon-copied {
            transform: rotate(0deg) scale(1);
            opacity: 1;
        }
    `}
`;

export const Container = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    min-height: 64px;
    margin: 0 12px;
    padding: 0 8px;
    overflow: hidden;

    background: rgb(22, 33, 70);
    border: 1px solid rgb(74, 85, 120);
    border-radius: 8px;

    ${media.SM`
        margin-top: 80px;
    `}

    &:hover {
        background: rgb(44, 58, 97);

        ${CopyTenant} {
            opacity: 1;
        }
    }

    ${media.SM`
        background: rgb(44, 58, 97);
        
        ${CopyTenant} {
            opacity: 1;
        }
    `}
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    width: 24px;
    height: 24px;
`;

export const CurrentTenant = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 162px;
`;

export const NoWrap = styled(Text)`
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
`;
